import "./ForegroundWrapper.css";

function ForegroundWrapper({ children }) {
    return <div className={"foreground"}>{children}</div>;
}

export default ForegroundWrapper;
